import {API_URL, apiPost} from '../api'

export const withdrawPostRetry = async (id: string) => {
    return await apiPost(API_URL, 'admin/withdraw/retry', {id: id})
}
